// extracted by mini-css-extract-plugin
export default {"editorRoot":"styles_editorRoot__uADcO","editorRootCompact":"styles_editorRootCompact__-8f4-"};